import React, { useEffect, useState } from "react";
import bannerVideo from "../../Assests/handa-realtor.mp4";
import {
  FaBath,
  FaBed,
  FaCheckSquare,
  FaCompressArrowsAlt,
  FaPhoneAlt,
  FaQuoteRight,
  FaRulerCombined,
} from "react-icons/fa";
import { CiLocationOn } from "react-icons/ci";
import { FaLocationDot } from "react-icons/fa6";
import image1 from "../../Assests/cta-handar-two.webp";
import Slider from "react-slick";
import mississauga from "../../Assests/MISSISSAUGA.webp";
import toronto from "../../Assests/Toranto.webp";
import hamilton from "../../Assests/Hamilton-1.webp";
import king from "../../Assests/king.webp";
import { Link, useNavigate } from "react-router-dom";
import parthhanda from "../../Assests/parth_handa1.webp";
import yourtrusted from "../../Assests/3d-rendering-modern-1-scaled.jpg";
import propertysearch from "../../Assests/cta-handar-two (1).webp";
import { IoMail } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import Aos from "aos";

export default function Homepage() {
  const [allProperties, setAllProperties] = useState([]);
  const [properties, setProperties] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [city, setCity] = useState("");
  const navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const data = [
    {
      id: 1,
      title: "MISSISSAUGA",
      image: mississauga,
    },
    {
      id: 2,
      title: "TORONTO",
      image: toronto,
    },
    {
      id: 3,
      title: "HAMILTON",
      image: hamilton,
    },
    {
      id: 4,
      title: "BRAMPTON",
      image: king,
    },
  ];

  const settingstest = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const datatest = [
    {
      name: "VIKRAM SHARMA",
      text: `The team at Handa Realtor is exceptional! They introduced me to investment options in Dubai that I hadn’t considered before. Their understanding of both the Canadian and Dubai markets is unmatched. I’ve already recommended them to a few friends looking for global investment opportunities.`,
    },
    {
      name: "PRIYA PATEL",
      text: `I recently sold my home in Toronto with the help of Handa Realtor, and I couldn’t be happier with the experience! Parth and his team were incredibly professional and made the entire process stress-free. From pricing my property just right to negotiating with buyers, everything was handled with expertise. I highly recommend them to anyone looking to sell their property in Canada!`,
    },
    {
      name: "ANJALI VERMA",
      text: `As a first-time homebuyer in Canada, I was nervous about the entire process, but Handa Realtor made it so smooth and stress-free. Parth patiently answered all my questions, helped me find the perfect home within my budget, and guided me every step of the way. I’m so grateful for their expertise and support. Highly recommend them to anyone looking to buy a home!`,
    },
    {
      name: "AISHA KHAN",
      text: `Parth and his team were amazing to work with! I was initially hesitant about investing in Dubai properties, but their knowledge and professionalism put me at ease. They made the entire process seamless, and I feel confident about my decision. If you're in Canada and considering Dubai investments, Handa Realtor is the way to go.`,
    },
    {
      name: "RAJIV MEHTA",
      text: `I recently connected with Parth Handa through his Dubai investment campaign, and I’m so glad I did! He explained everything about the Dubai real estate market in a way that was easy to understand. The opportunities he presented were not only lucrative but also perfectly aligned with my investment goals. Highly recommend his expertise!`,
    },
  ];

  const handleformsubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://handarealtor.ca/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          message,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        console.log("Form Submitted Successfully", data);

        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
      } else {
        console.log("Submission Failed", data);
      }
    } catch (error) {
      console.log("Something Went Wrong", error);
    }
  };

  const handleCityChange = (e) => {
    const val = e.target.value;

    const formattedValue =
      val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();

    setCity(formattedValue);
  };

  const handleSearch = (e) => {
    e.preventDefault();

    if (!city.trim()) return;

    navigate(`/properties?city=${city}`);
  };

  const filterProperties = (data, tab) => {
    return data
      .filter(
        (item) => item.BedroomsTotal >= 3 && item.BathroomsTotalInteger >= 3,
      )
      .filter((item) => {
        if (tab === "All") return true;
        if (tab === "Buy") return item.TransactionType === "For Sale";
        if (tab === "Rent") return item.TransactionType === "For Lease";
        if (tab === "Sell") return item.TransactionType === "For Sale";
        return true;
      })
      .slice(0, 4);
  };

  useEffect(() => {
    const fetchPropertiesWithImages = async () => {
      try {
        const res = await fetch("https://handarealtor.ca/property-list");
        const data = await res.json();

        const filtered = data.value.filter(
          (item) => item.BedroomsTotal >= 3 && item.BathroomsTotalInteger >= 3,
        );

        const propertiesWithImages = await Promise.all(
          filtered.map(async (item) => {
            try {
              const imgRes = await fetch(
                `https://handarealtor.ca/property-images/${item.ListingKey}`,
              );
              const imgData = await imgRes.json();
              return {
                ...item,
                images: imgData.images || [],
              };
            } catch {
              return { ...item, images: [] };
            }
          }),
        );

        setAllProperties(propertiesWithImages);
        setProperties(filterProperties(propertiesWithImages, "All"));
        setLoading(false);
      } catch (err) {
        console.error("Error:", err);
        setLoading(false);
      }
    };

    fetchPropertiesWithImages();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setProperties(filterProperties(allProperties, tab));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);
  return (
    <div className="homepage">
      <div className="video-banner">
        <video autoPlay loop muted playsInline className="banner-video">
          <source src={bannerVideo} type="video/mp4" />
        </video>

        <div className="overlay"></div>

        <div className="banner-content">
          <h1
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            Find Your Dream Home
            <br /> with Trusted Realtor
          </h1>
          <p
            className="mb-1"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            Buy, Sell, Rent or Invest in Premium Properties
          </p>
          <p>with Complete Transparency & Expert Guidance</p>
          <div className=" mt-4">
            <form
              className="d-flex justify-content-center"
              onSubmit={handleSearch}
            >
              <div
                className="input-group input-group-mobile"
                style={{ width: "40%" }}
              >
                <input
                  type="search"
                  className="form-control p-2"
                  placeholder="Search Properties..."
                  value={city}
                  onChange={handleCityChange}
                />

                <button type="submit" className="btn btn-dark">
                  Search
                </button>
              </div>
            </form>
          </div>
          <div className="container pt-5">
            <div className="row justify-content-center text-center">
              <div className="col-md-2 mb-3">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <FaCheckSquare style={{ color: "#af8e5b" }} />
                  <p className="mb-0">500+ Happy Clients</p>
                </div>
              </div>

              <div className="col-md-2 mb-3">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <FaCheckSquare style={{ color: "#af8e5b" }} />
                  <p className="mb-0">Expert Agents</p>
                </div>
              </div>

              <div className="col-md-2 mb-3">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <FaCheckSquare style={{ color: "#af8e5b" }} />
                  <p className="mb-0">Premium Listings</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="properties-section">
        <div className="container">
          <p
            className="text-center text-uppercase text-muted"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            Explore Properties
          </p>
          <h2
            className="text-center mb-4"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            Our Latest Listings
          </h2>
          <div className="d-flex justify-content-center mb-4">
            <div className="tab-wrapper d-flex">
              {["All", "Buy", "Sell", "Rent"].map((tab) => (
                <button
                  key={tab}
                  className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                  onClick={() => handleTabChange(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
          <div className="row">
            {properties.map((item) => (
              <div
                className="col-sm-12 col-md-12 col-lg-12 col-xl-3 mt-4"
                key={item.id}
              >
                <Link
                  to={`/property/${item.ListingKey}`}
                  className="text-decoration-none text-dark"
                >
                  <div className="card h-100 border-0 shadow rounded-4">
                    <div className="position-relative">
                      <img
                        src={
                          item.images.length > 0
                            ? item.images[0]
                            : "https://placehold.co/400x220?text=No+Image"
                        }
                        className="card-img-top"
                        alt={item.PublicRemarks}
                        style={{ height: "220px", objectFit: "cover" }}
                      />
                    </div>

                    <div className="card-body">
                      <h5 className="fw-semibold mb-1">
                        {item.CountyOrParish}
                      </h5>

                      <p className="text-dark small mb-2">
                        <FaLocationDot className="me-1 text-dark" />{" "}
                        {item.CrossStreet}
                      </p>

                      <div className="d-flex justify-content-between small text-dark pt-2 pb-2">
                        <span>
                          <FaBath className="me-1" />{" "}
                          {item.BathroomsTotalInteger} Bathrooms
                        </span>
                        <span>
                          <FaBed className="me-1" /> {item.BedroomsTotal} Beds
                        </span>
                        <span>
                          <FaCompressArrowsAlt className="me-1" />{" "}
                          {item.LotWidth}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="properties-section">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4">
              <p
                className="text-start text-uppercase text-muted"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                CITIES
              </p>
              <h2
                className="text-start mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Featured
                <br /> Neighborhood
              </h2>
              <p
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Discover one of the city’s most desirable locations, offering
                the perfect blend of comfort, convenience, and modern living.
                Enjoy easy access to top schools, shopping centers, parks, and
                restaurants. With beautiful homes, safe surroundings, and a
                vibrant community, it’s ideal for families, professionals, and
                investors seeking long-term value and a better lifestyle.
              </p>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
              <Slider {...settings}>
                {data.map((item) => (
                  <div key={item.id} className="px-2">
                    <div className="card border-0">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="img-fluid w-100 rounded city-img"
                      />

                      <div className="pt-2">
                        <h6 className="text-uppercase mb-0">{item.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-handa py-5">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-6"></div>

            <div className="col-md-6 text-dark">
              <p
                className="text-uppercase mb-2"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Let’s Find Your Dream Home
              </p>

              <h2
                className="mb-3"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Turn Your Homeownership Dream into Reality
              </h2>

              <p
                className="mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Buying a home is one of the most important decisions you’ll ever
                make— especially in fast-moving markets like Toronto, Whitby,
                Oshawa, Ajax, Pickering, and nearby areas.
              </p>

              <Link
                to="#"
                className="common_button"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                ENQUIRE NOW
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container ">
          <div className="row g-0 align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 d-flex align-items-center ">
              <div className="px-4 px-md-5 mx-auto">
                <p
                  className="text-uppercase"
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  About
                </p>

                <h2
                  className=" "
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  PARTH HANDA
                </h2>

                <p
                  className=" mb-3"
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  I’m Parth Handa, a dedicated real estate Sales Representative
                  committed to honesty, knowledge, and client-focused service. I
                  bring a fresh perspective and diverse skills to help you
                  navigate your real estate journey with ease in Canada as well
                  as Dubai.
                </p>

                <p
                  className=" mb-3"
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  Fluent in English and Hindi, I connect with a wide range of
                  clients, understanding their unique needs and offering
                  innovative solutions.
                </p>

                <p
                  className=" fst-italic mb-3"
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  “The only limit to our realization of tomorrow is our doubts
                  of today.” – Franklin D. Roosevelt
                </p>

                <p
                  className=""
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  Let’s turn your real estate dreams into reality with
                  professionalism and a personal touch!
                </p>
              </div>
            </div>

            <div
              className="col-sm-12 col-md-12 col-lg-12 col-xl-6 bg-dark "
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in-back"
              data-aos-delay="300"
              data-aos-offset="0"
            >
              <img
                src={parthhanda}
                alt="Parth Handa"
                className="w-100 h-100 about-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="">
        <div className="container ">
          <div className="row g-0 align-items-stretch">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 d-flex align-items-center bg-dark text-white">
              <div className="px-4 px-md-5 mx-auto py-4 py-md-5">
                <h2
                  className=""
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  Your Trusted Property Guide
                </h2>

                <p
                  className="mb-0 "
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  A professional realtor simplifies your entire property journey
                  with expert guidance and market insight. They provide access
                  to exclusive listings, track market trends, and help you find
                  the right property at the best price. From arranging viewings
                  and offering honest advice to negotiating favorable deals,
                  they support you at every step.
                </p>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
              <img
                src={yourtrusted}
                alt="Your Trusted Realtor"
                className="img-fluid trusted-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container ">
          <div className="row g-0 align-items-stretch">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
              <img
                src={propertysearch}
                alt="Your Trusted Realtor"
                className="img-fluid trusted-img"
              />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 d-flex align-items-center  text-dark">
              <div className="px-4 px-md-5 mx-auto py-4 py-md-5">
                <h2
                  className=""
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  Easy Property Search
                </h2>

                <p
                  className="mb-0 "
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-delay="300"
                  data-aos-offset="0"
                >
                  Finding the right property becomes significantly easier when
                  you have a professional realtor by your side. They take the
                  time to understand your specific needs, preferences, and
                  budget, and then shortlist the most suitable options for you.
                  With access to verified and exclusive listings, they ensure
                  you explore only genuine opportunities. From scheduling
                  property visits and guiding you during inspections to
                  negotiating the best deal and handling documentation, they
                  streamline the entire process. This not only saves you time
                  and effort but also ensures a smooth, efficient, and
                  completely hassle-free property buying or renting experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="properties-section"
        style={{ backgroundColor: "#E9E9E9" }}
      >
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-12">
              <p
                className="text-center text-uppercase text-muted"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Explore Properties
              </p>
              <h2
                className="text-center mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Client Feedback
              </h2>
              <Swiper
                modules={[Autoplay]}
                spaceBetween={20}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={true}
                breakpoints={{
                  0: {
                    slidesPerView: 1, // mobile → 1 card
                  },
                  768: {
                    slidesPerView: 2, // tablet → 2 cards
                  },
                  992: {
                    slidesPerView: 3, // desktop → 3 cards
                  },
                }}
              >
                {datatest.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="card border-0 bg-light text-center h-100 p-4 rounded-3">
                      <h6 className="fw-semibold mb-3">{item.name}</h6>
                      <p className="small">"{item.text}"</p>
                      <div className="d-flex justify-content-center mt-auto">
                        <div
                          className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: "60px",
                            height: "60px",
                            fontSize: "20px",
                          }}
                        >
                          <FaQuoteRight />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      <section className="properties-section">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
              <p
                className="text-start text-uppercase text-muted"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                CONTACT INFO
              </p>

              <h2
                className="text-start mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Our Experts Are Ready to Work With You
              </h2>

              <p
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Get in touch with our team for trusted guidance, responsive
                communication, and local Nashville market expertise.
              </p>

              <div className="d-flex align-items-center mt-3">
                <FaPhoneAlt className="me-2 text-dark fs-3" />
                <div>
                  <h5 className="mb-0">Phone</h5>
                  <Link
                    to="tel:+16479876291"
                    className="text-decoration-none "
                    style={{ color: "#7A7A7A" }}
                  >
                    +1 (647) 987-6291
                  </Link>
                </div>
              </div>
              <div className="d-flex align-items-center mt-3">
                <IoMail className="me-2 text-dark fs-3" />
                <div>
                  <h5 className="mb-0">Email</h5>
                  <Link
                    to="mailto:handa.realtor@gmail.com"
                    className="text-decoration-none "
                    style={{ color: "#7A7A7A" }}
                  >
                    handa.realtor@gmail.com
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-0 mt-md-5 d-flex justify-content-xl-end">
              <form
                className="shadow rounded-3 p-4 w-100 w-md-75"
                onSubmit={handleformsubmit}
              >
                <div className="row">
                  <div className="col-12 mb-3">
                    <input
                      type="text"
                      className="form-control rounded-3"
                      placeholder="Your Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="col-12  mb-3">
                    <input
                      type="email"
                      className="form-control rounded-3"
                      placeholder="Email Address"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="col-12  mb-3">
                    <input
                      type="tel"
                      className="form-control rounded-3"
                      placeholder="Phone Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <textarea
                      className="form-control rounded-3"
                      rows="6"
                      placeholder="Your Message"
                      required
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="col-12 text-center">
                    <button type="submit" className="btn btn-dark px-4 w-100">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
